export const ORDER_TYPES = {
  MAIL: 'MailSuite',
  SITE: 'Site',
  DOMAIN: 'NeoDomain',
};

export const MAIL_SERVICE_TYPES = {
  PARTNER_HOSTING: 'partner_hosting',
  FLOCK_CLOUD: 'flock_cloud',
};

export const BUNDLE_STATUSES = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  DELETED: 'deleted',
} as const;

export const ORDER_STATUSES = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  PENDING: 'pending',
  DELETED: 'deleted',
  SUSPENDED_PENDING: 'suspended_pending',
} as const;
